import { Store } from "pullstate";
import { UserClaim } from "types/claimTypes";

export const USER_STORAGE_KEY = "user";

export type AuthStore = {
  id: string | null;
  email?: string | null;
  isLoggedIn?: boolean;
  firstName?: string | null;
  lastName?: string | null;
  organizationId?: string | null;
  impersonatingUserEmail?: string | null;
  claims: (UserClaim | undefined)[];
};

export const getAuthInitialState = (): AuthStore => {
  const authString = localStorage.getItem(USER_STORAGE_KEY);
  return authString ? JSON.parse(authString) as AuthStore : {
    id: null,
    isLoggedIn: false,
    claims: [],
  };
};
const authStore = new Store<AuthStore>(getAuthInitialState());

export default authStore;
